import type { SVGProps } from 'react'

interface MarketIconProps extends SVGProps<SVGSVGElement> {}

export function MarketIcon(props: MarketIconProps) {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5491 3.2579L15.2578 9.54925L13.4696 7.76111C13.2579 7.54879 12.9136 7.54879 12.7018 7.76111L7.6556 12.8073L5.86746 11.0192C5.65569 10.8069 5.31142 10.8069 5.09964 11.0192L3.08561 13.0332L1.14 13.0321C0.840252 13.0321 0.596436 13.2754 0.596436 13.5746C0.596436 13.8743 0.839701 14.1182 1.1389 14.1182L3.30987 14.1192C3.45431 14.1192 3.59224 14.0622 3.69433 13.9601L5.48355 12.1709L7.27169 13.9591C7.48347 14.1714 7.82774 14.1714 8.03951 13.9591L13.0857 8.91284L14.8739 10.701C15.0856 10.9133 15.4299 10.9133 15.6417 10.701L22.317 4.02572V7.05899C22.317 7.35873 22.5602 7.602 22.86 7.602C23.1597 7.602 23.403 7.35873 23.403 7.05899V2.71489C23.403 2.41514 23.1597 2.17188 22.86 2.17188H18.5159C18.2161 2.17188 17.9728 2.41514 17.9728 2.71489C17.9728 3.01463 18.2161 3.2579 18.5159 3.2579H21.5491Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.85451 15.737V20.0807C3.85451 20.3805 3.61124 20.6237 3.3115 20.6237H1.13945C0.839705 20.6237 0.596436 20.3805 0.596436 20.0807V15.737C0.596436 15.4372 0.839705 15.1941 1.13945 15.1941H3.3115C3.61124 15.1941 3.85451 15.4372 3.85451 15.737Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3709 15.7266V20.0696C10.3709 20.3696 10.1276 20.6131 9.82786 20.6131H7.65581C7.35606 20.6131 7.11279 20.3696 7.11279 20.0696V15.7266C7.11279 15.4267 7.35606 15.1838 7.65581 15.1838H9.82786C10.1276 15.1838 10.3709 15.4267 10.3709 15.7266Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8867 12.4957V20.0985C16.8867 20.2423 16.8297 20.3806 16.7276 20.4826C16.6261 20.5842 16.4876 20.6415 16.3437 20.6415H14.1717C14.0278 20.6415 13.8893 20.5842 13.7878 20.4826C13.6857 20.3806 13.6287 20.2423 13.6287 20.0985V12.4957C13.6287 12.3519 13.6857 12.2136 13.7878 12.1115C13.8893 12.01 14.0278 11.9526 14.1717 11.9526H16.3437C16.4876 11.9526 16.6261 12.01 16.7276 12.1115C16.8297 12.2136 16.8867 12.3519 16.8867 12.4957Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4031 9.18748V20.0437C23.4031 20.1881 23.3461 20.3258 23.244 20.4279C23.1425 20.5293 23.004 20.5867 22.8601 20.5867H20.688C20.5441 20.5867 20.4057 20.5293 20.3041 20.4279C20.202 20.3258 20.145 20.1881 20.145 20.0437V9.18748C20.145 9.04393 20.202 8.90544 20.3041 8.80412C20.4057 8.70195 20.5441 8.64453 20.688 8.64453H22.8601C23.004 8.64453 23.1425 8.70195 23.244 8.80412C23.3461 8.90544 23.4031 9.04393 23.4031 9.18748Z"
        fill="currentColor"
      />
      <path
        d="M4.39751 8.68808C4.6974 8.68808 4.94052 8.44496 4.94052 8.14506C4.94052 7.84517 4.6974 7.60205 4.39751 7.60205C4.09761 7.60205 3.85449 7.84517 3.85449 8.14506C3.85449 8.44496 4.09761 8.68808 4.39751 8.68808Z"
        fill="currentColor"
      />
      <path
        d="M8.74174 8.68808C9.04164 8.68808 9.28476 8.44496 9.28476 8.14506C9.28476 7.84517 9.04164 7.60205 8.74174 7.60205C8.44185 7.60205 8.19873 7.84517 8.19873 8.14506C8.19873 8.44496 8.44185 8.68808 8.74174 8.68808Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.66959 6.07957L2.66339 1.08603H1.13969C0.839949 1.08603 0.59668 0.842756 0.59668 0.543013C0.59668 0.24327 0.839949 0 1.13969 0H3.09454C3.34704 0 3.56588 0.173761 3.62344 0.419746L4.03232 2.17205H9.58897C9.75188 2.17205 9.9061 2.24481 10.0093 2.37079C10.1124 2.49677 10.1537 2.66185 10.1217 2.82149L9.47006 6.07957C9.41901 6.3337 9.19637 6.51616 8.93735 6.51616H4.20229C3.94328 6.51616 3.72063 6.3337 3.66959 6.07957Z"
        fill="currentColor"
      />
    </svg>
  )
}
